import { render, staticRenderFns } from "./Beneficiaires.vue?vue&type=template&id=a454b6c0&scoped=true&"
import script from "./Beneficiaires.vue?vue&type=script&lang=js&"
export * from "./Beneficiaires.vue?vue&type=script&lang=js&"
import style0 from "./Beneficiaires.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Beneficiaires.vue?vue&type=style&index=1&id=a454b6c0&lang=scss&scoped=true&"
import style2 from "./Beneficiaires.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a454b6c0",
  null
  
)

export default component.exports